import React, { Component } from 'react';
interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
interface State {
  hasError: boolean;
  error?: Error;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <div className="min-h-screen flex items-center justify-center bg-cream-light p-6" data-id="element-42">
            <div className="max-w-md text-center" data-id="element-43">
              <h1 className="font-serif text-3xl font-bold text-gray-900 mb-3" data-id="element-44">
                Algo salió mal
              </h1>
              <p className="text-gray-600 mb-6" data-id="element-45">
                Estamos teniendo un pequeño problema. Por favor refresca la
                página.
              </p>
              <button onClick={() => window.location.reload()} className="bg-terracotta hover:bg-terracotta-dark text-white font-medium px-6 py-3 rounded-2xl transition-colors" data-id="element-46">
                Refrescar
              </button>
            </div>
          </div>;
    }
    return this.props.children;
  }
}